/**
 * @param {HTMLElement} textareaElement
 */
export default (textareaElement) => {
  if (textareaElement && !textareaElement.hasCounter) {
    const counterElement = document.getElementById(textareaElement.getAttribute('aria-describedby'))
    const limit = Number(textareaElement.getAttribute('maxlength'))
    if (counterElement && limit) {
      counterElement.innerText = String(limit - textareaElement.value.length)
      textareaElement.addEventListener(
        'input',
        () => {
          counterElement.innerText = String(limit - textareaElement.value.length)
        },
      )
      textareaElement.hasCounter = true
    }
  }
}
